import { useLayoutEffect, useCallback, memo } from 'react';
import styled from 'styled-components';

import { CETUSTEK } from 'constants/vendor';
import Paginator from 'components/Paginator';

import ByDayFilterSection from '../../components/ByDayFilterSection';
import ByDayTagPanelSection from '../../components/ByDayTagPanelSection';
import ByDayInvoiceTable from '../../components/ByDayInvoiceTable';

import { COLUMN_KEYS } from '../../hooks/useByDayInvoiceTableConfig';
import { E2E_CETUSTEK_BY_DAY_PREFIX } from '../../constants';

const fixedChannelConfig = [];

const TableContentWrapper = styled.div`
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.SNOW_200};
`;

const PaginatorWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
`;

const EXCLUDE_COLUMNS_KEYS = [COLUMN_KEYS.ZERO_TAX_AMOUNT];

const DayList = ({
  parameters,
  updateParams,
  list,
  isLoadingList,
  getByDayList,
  pagination,
  channels,
}) => {
  const onPageChange = useCallback(
    (page) => {
      updateParams({ page: page.toString() });
    },
    [updateParams],
  );

  useLayoutEffect(() => {
    getByDayList({ ...parameters });
  }, [parameters, getByDayList]);

  return (
    <>
      <ByDayFilterSection
        e2eFeaturePrefix={E2E_CETUSTEK_BY_DAY_PREFIX}
        vendorType={CETUSTEK}
        fixedChannelConfig={fixedChannelConfig}
        channels={channels}
        parameters={parameters}
        updateParams={updateParams}
      />
      <ByDayTagPanelSection
        e2eFeaturePrefix={E2E_CETUSTEK_BY_DAY_PREFIX}
        vendorType={CETUSTEK}
        channels={channels}
        parameters={parameters}
        updateParams={updateParams}
      />
      <TableContentWrapper>
        <ByDayInvoiceTable
          e2eFeaturePrefix={E2E_CETUSTEK_BY_DAY_PREFIX}
          excludeColumnKeys={EXCLUDE_COLUMNS_KEYS}
          isEmpty={!isLoadingList && pagination && pagination.total_count === 0}
          isLoading={isLoadingList}
          tableData={list}
        />
      </TableContentWrapper>
      {!isLoadingList && pagination && pagination.total_pages > 1 && (
        <PaginatorWrapper>
          <Paginator
            totalCount={pagination.total_count}
            onPageChange={onPageChange}
            page={pagination.current_page}
            limit={pagination.per_page}
          />
        </PaginatorWrapper>
      )}
    </>
  );
};

export default memo(DayList);
